var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7307 0.398438C9.47455 0.398438 0.375 9.56507 0.375 20.9054C0.375 29.9704 6.20539 37.6437 14.2937 40.3595C15.3049 40.5637 15.6754 39.9183 15.6754 39.3754C15.6754 38.8999 15.642 37.2704 15.642 35.5725C9.97954 36.795 8.80038 33.1279 8.80038 33.1279C7.89039 30.7512 6.54206 30.1404 6.54206 30.1404C4.68873 28.8842 6.67706 28.8842 6.67706 28.8842C8.73288 29.02 9.81163 30.9891 9.81163 30.9891C11.6312 34.1125 14.5633 33.23 15.7429 32.6866C15.9112 31.3625 16.4508 30.4458 17.0237 29.9366C12.5075 29.4612 7.7558 27.6958 7.7558 19.8188C7.7558 17.578 8.56413 15.7446 9.84496 14.3188C9.64288 13.8096 8.93496 11.7042 10.0475 8.88632C10.0475 8.88632 11.7662 8.34299 15.6416 10.9913C17.3008 10.5424 19.0119 10.3141 20.7307 10.3121C22.4495 10.3121 24.2016 10.5501 25.8195 10.9913C29.6953 8.34299 31.414 8.88632 31.414 8.88632C32.5265 11.7042 31.8182 13.8096 31.6161 14.3188C32.9307 15.7446 33.7057 17.578 33.7057 19.8188C33.7057 27.6958 28.954 29.4271 24.4041 29.9366C25.1457 30.5816 25.7857 31.8037 25.7857 33.7391C25.7857 36.4891 25.7524 38.6962 25.7524 39.3749C25.7524 39.9183 26.1232 40.5637 27.1341 40.3599C35.2224 37.6433 41.0527 29.9704 41.0527 20.9054C41.0861 9.56507 31.9532 0.398438 20.7307 0.398438Z",
    fill: "#FFF9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github_icon.f5c788b68238cbd7ad038da994e72f76.svg";
export { ForwardRef as ReactComponent };